function visitElements(elements) {
  if (!Array.isArray(elements)) return;

  elements.forEach((element) => {
    if (!element || typeof element !== "object") return;

    if (element.type === "file") {
      // Force SurveyJS to use onUploadFiles (server-backed storage) instead of base64.
      element.storeDataAsText = false;
      // Prevent submit before uploads finish.
      element.waitForUpload = true;
      if (element.allowMultiple !== true) {
        element.allowMultiple = false;
      }
    }

    // Panels / nested elements
    if (Array.isArray(element.elements)) {
      visitElements(element.elements);
    }

    // Paneldynamic template elements
    if (Array.isArray(element.templateElements)) {
      visitElements(element.templateElements);
    }
  });
}

export function ensureS3FileQuestions(surveyJson) {
  if (!surveyJson || typeof surveyJson !== "object") return surveyJson;

  if (Array.isArray(surveyJson.pages)) {
    surveyJson.pages.forEach((page) => {
      if (page && Array.isArray(page.elements)) {
        visitElements(page.elements);
      }
    });
  }

  if (Array.isArray(surveyJson.elements)) {
    visitElements(surveyJson.elements);
  }

  return surveyJson;
}

